import { AuthenticatedHttpService } from './HttpService';
import { firestoreDocumentById, executeQuery } from '../firebase/firestore';

export class AnalysesSearchService extends AuthenticatedHttpService {
  async searchByUrl(url) {
    const httpClient = await this.prepareHttpClient(process.env.VUE_APP_ASSISTANT_URL);
    const query = {
      max_results: 1000,
      scorings: [],
      filters: [
        {
          url: {
            param: [url],
            kind: 'Include',
          },
        },
        {
          DocKind: {
            param: 'Analysis',
            kind: 'Include',
          },
        },
      ],
    };
    const response = await httpClient.post('/search/complex', query);

    if (response.data && response.data.items) {
      return Promise.all(response.data.items
        .map(async item => {
          const id = item.analysis_id;
          const documentId = item.document.id;

          const analysis = await executeQuery(firestoreDocumentById('analyses', id));
          let lastEdited = new Date().toISOString();

          if (analysis.auditInfo && analysis.auditInfo.modifiedOn) {
            lastEdited = new Date(analysis.auditInfo.modifiedOn).toISOString();
          }

          return {
            id,
            documentId,
            lastEdited,
          };
        }));
    }
    return [];
  }
}
